<template>
  <div class="container-fluid home">
    <vue-headful
            :title="`Brokers Real Estate`"
        />
    <div class="row">
      <div id="home" class="col-sm-12 text-center">
        <div class="background">
          <!-- <img src="../assets/GilmoreLogo.png" class="bannerLogo" alt> -->
          <v-img
            :src="require('@/assets/logo.png')"
            class="bannerLogoLg hidden-sm-and-down mx-auto"
            alt
          ></v-img>
          <!-- <Search /> -->
          <div class="col-8 mx-auto">
            <Search />
          </div>
         
          <!-- <v-img
            :src="require('@/assets/logo.png')"
            class="bannerLogoSm hidden-md-and-up text-center mx-auto"
            alt
          ></v-img> -->
          <br>
          <!-- <h1 class="white--text tagline">Good People. Good Real Estate</h1> -->
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import Search from '../components/Search.vue'
export default {

  data() {
    return {
      search: ''
      
    }
  },
  components: {
    Search: Search
  },
  methods:{
    searchListings(){
      this.$router.push("/search?param="+this.search);
      
    }
  }
  
};
</script>

<style scoped>
.home{
  margin-top: 40px;
}
.container-fluid {
  padding: 0;
}
#home {
  background: url("../assets/texas-107.jpg");
  max-width: 100%;
  height: 50rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bannerLogoSm {
  margin-top: 10rem;
  width: 15rem;
}
.bannerLogoLg {
  margin-top: 10rem;
  width: 25rem;
}
.tagline {
  -webkit-text-stroke: 1px black;
  color: white;
  text-shadow: 2px 2px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000,
    -1px 1px 0 #000, 1px 1px 0 #000;
}
</style>

